module.exports = "<a class=\"ui-card ui-card-hover kd-item kd-item--large padding-md\"\r\n    ui-sref=\"cliente.informacion({idCliente: $ctrl.data.cliente_id})\">\r\n  <div class=\"flex\">\r\n    <div class=\"--text-bold\">{{::$ctrl.data.nombre}}</div>\r\n    <div>RFC: {{::$ctrl.data.rfc}}</div>\r\n  </div>\r\n  <empresa-clientes-eliminar\r\n      ng-if=\"$ctrl.editable\"\r\n      empresa-id=\"$ctrl.empresaId\"\r\n      data=\"$ctrl.data\"\r\n      on-delete=\"$ctrl.eliminar($event.detail)\"></empresa-clientes-eliminar>\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/empresa/components/clientes/lista/item/template.html
// module id = 2464
// module chunks = 0